import type { RouteConfig } from 'vue-router'

export const VideoRouter: RouteConfig[] = [
  {
    path: '/video',
    component: async () => import('./video.vue'),
  },
]
